import React from "react";
import { getColor } from "./InSilicoPredictionsHelpers";
import { cropNumber } from "../../../../common/helpers/helpers";
import * as urls from "./InSilicoPredictionsUrls";
import VersionText from "../../../../components/atoms/VersionText";
import HelperText from "../../../../components/atoms/HelperText";

export const displayDannData = (dann, schema, res, thresholds) => {
  const color = getColor("dann", dann.dann_score, thresholds);
  return (
    dann.dann_score && (
      <tr key="dann" className="dbnsfp-row">
        <td width="20%">
          <a href={urls.dannUrl} target="_blank">
            {schema.dann_snvs.items.properties.dann_score.label.split(" ")[0]}
          </a>
          <HelperText fieldDescriptionKey="DANN Score" />
          <br />
          {res.dann_snvs && (
            <VersionText versionText={res.dann_snvs[0].version} />
          )}
        </td>
        <td>
          <div className="varsome-horiz-list-label varsome-dbnsfp-label">
            {schema.dann_snvs.items.properties.dann_score.label
              .split(" ")
              .slice(1)
              .join(" ")}
          </div>
          <div className="varsome-horiz-list-value" style={{ color }}>
            {cropNumber(dann.dann_score)}
          </div>
        </td>
        <td colSpan="5" />
      </tr>
    )
  );
};
